import { useParams } from '@tanstack/react-router'
import CourseAboutSection from '#/features/courses/components/CourseAboutSection'
import CourseKeyFeaturesSection from '#/features/courses/components/CourseKeyFeaturesSection'
import CourseWhySection from '#/features/courses/components/CourseWhySection'
import CourseWhatYouLearnOld from '#/features/courses/components/CourseWhatYouLearnOld'
import CourseHeroSection from '#/features/courses/components/CourseHeroSection'
import PlansSection from '#/features/plans/components/PlansSection'
import { useCourse } from '#/features/courses/hooks/useCourse'
import PageTransition from '#/components/common/PageTransition'
import AboutTestimonialsSection from '#/features/about/components/AboutTestimonialsSection'

export default function CourseDetailsPage() {
  const params = useParams({ strict: false })
  const courseId = (params as any).courseId || ''
  const { data: course } = useCourse(courseId)

  return (
    <PageTransition>
      <main className="relative flex flex-col">
        <CourseHeroSection course={course} />
        <CourseAboutSection course={course} />
        <CourseKeyFeaturesSection course={course} />
        <CourseWhySection />
        <CourseWhatYouLearnOld course={course} />
        <AboutTestimonialsSection />
        <PlansSection />
      </main>
    </PageTransition>
  )
}
